module.exports = __webpack_public_path__ + "static/media/mehron-cross.ac3d9d58.svg";